export default "__VITE_ASSET__adN3JVCJ__"